<!-- 组织信息 -->
<template>
  <div class="organization-info-view">
    <p class="info-title">关键人员信息</p>

    <div class="borganization-info-block">
      <div class="table-box ly_table_light">
        <el-table
          :data="keyData"
          border
          style="width: 650px"
          header-cell-class-name="ly_table_light_header"
          cell-class-name="ly_table_light_cell"
        >
          <el-table-column
            prop="talentId"
            label="超级个体人员编号"
            align="center"
            width="260"
          ></el-table-column>

          <el-table-column
            prop="userName"
            label="超级个体人员姓名"
            align="center"
            width="390"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <p class="info-title">会长</p>

    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="120px"
      class="demo-form"
    >
      <div class="borganization-info-block">
        <el-form-item label="人员编号：" prop="memberId" required>
          <el-input
            v-model="form.memberId"
            placeholder="请输入会长人员编号"
          ></el-input>
        </el-form-item>

        <el-form-item label="人员姓名：" prop="memberName" required>
          <el-input
            v-model="form.memberName"
            placeholder="请输入会长人员姓名"
          ></el-input>
        </el-form-item>
      </div>
      <p class="info-title">副会长 1</p>
      <div class="borganization-info-block">
        <div class="table-box ly_table_light">
          <el-table
            :data="memberData"
            border
            style="width: 650px"
            header-cell-class-name="ly_table_light_header"
            cell-class-name="ly_table_light_cell"
          >
            <el-table-column
              prop="talentId"
              label="人员编号"
              align="center"
              width="260"
            ></el-table-column>

            <el-table-column
              prop="userName"
              label="人员姓名"
              align="center"
              width="390"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <p class="info-title">秘书长</p>
      <div class="borganization-info-block">
        <el-form-item label="人员编号：" prop="secretaryId" required>
          <el-input
            v-model="form.secretaryId"
            placeholder="请输入秘书长人员编号"
          ></el-input>
        </el-form-item>

        <el-form-item label="人员姓名：" prop="secretaryName" required>
          <el-input
            v-model="form.secretaryName"
            placeholder="请输入秘书长人员姓名"
          ></el-input>
        </el-form-item>
      </div>
      <p class="info-title">副秘书长 1</p>
      <div class="borganization-info-block">
        <div class="table-box ly_table_light">
          <el-table
            :data="secretaryData"
            border
            style="width: 650px"
            header-cell-class-name="ly_table_light_header"
            cell-class-name="ly_table_light_cell"
          >
            <el-table-column
              prop="talentId"
              label="人员编号"
              align="center"
              width="260"
            ></el-table-column>

            <el-table-column
              prop="userName"
              label="人员姓名"
              align="center"
              width="390"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
// api
import { getOrganizationInfo } from "@/api/customCompany.js";
export default {
  data() {
    return {
      keyData: [
        {
          talentId: "",
          userName: "",
        },
      ],
      memberData: [
        {
          talentId: "",
          userName: "",
        },
      ],
      secretaryData: [
        {
          talentId: "",
          userName: "",
        },
      ],
      isInit: false,
      form: {
        memberId: "",
        memberName: "",
        secretaryId: "", // 秘书长人员编号
        secretaryName: "", // 秘书长人员姓名
      },
      rules: {
        memberId: [
          { required: true, message: "请输入会长人员编号", trigger: "blur" },
        ],
        memberName: [
          { required: true, message: "请输入会长人员姓名", trigger: "blur" },
        ],
        secretaryId: [
          { required: true, message: "请输入秘书长人员编号", trigger: "blur" },
        ],
        secretaryName: [
          { required: true, message: "秘书长人员姓名", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    getInfo() {
      if (this.isInit) {
        return;
      }

      getOrganizationInfo({ id: this.$route.query.id }).then((res) => {
        if (res.code == 200) {
          this.isInit = true;

          if (res.data && Array.isArray(res.data.zcRecruitmentList)) {
            this.zcRecruitmentList = res.data.zcRecruitmentList;
          }

          if (res.data && Array.isArray(res.data.zcTeamList)) {
            this.zcTeamList = res.data.zcTeamList;
          }
        }
      });
    },
    submit() {
      this.$refs.chamberForm.validate((valid) => {
        if (valid) {
          console.log("表单数据:", this.form);
          this.$message.success("提交成功！");
        } else {
          this.$message.error("请检查表单填写是否正确");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.organization-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .table-box {
    padding-left: 190px;
    padding-bottom: 30px;

    .table-title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-size: 16px;
      color: #333333;

      &::before {
        content: "";
        display: block;
        margin-right: 4px;
        width: 7px;
        height: 7px;
        background-color: #1e9fff;
        border-radius: 50%;
      }
    }
  }
}
::v-deep .el-table--scrollable-x .el-table__body-wrapper {
  overflow: hidden;
}
.borganization-info-block {
  border-bottom: 20px solid #d8efff;
}
.borganization-info-block:last-child{
  border: none;
}
::v-deep .el-input__inner,
::v-deep .el-textarea__inner,
::v-deep .el-textarea {
  width: 470px;
}
</style>
